export default "__VITE_ASSET__B9_0a$ti__"